// routes.js
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';

import ListTest from '../pages/tests/List';
import AddTest from '../pages/tests/AddUpdate';
import TestAttempt from '../pages/tests/Attempt';

import InterviewList from '../pages/interviews/List';
import AddInterview from '../pages/interviews/AddUpdate';

import PackageList from '../pages/packages/List';
import AddPackage from '../pages/packages/AddUpdate';

import CategoryList from '../pages/categories/List';
import AddCategory from '../pages/categories/AddUpdate';


import SystemUserList from '../pages/system_users/List';
import AddSystemUser from '../pages/system_users/AddUpdate';

import RoleList from '../pages/roles/List';
import AddRole from '../pages/roles/AddUpdate';

import UserList from '../pages/users/List';
import AddUser from '../pages/users/AddUpdate';

import PaymentList from '../pages/payments/List';
import NotFound from '../pages/NotFound'; 
import Account from '../pages/Account';



const routes = [
    {
        path: '/dashboard',
        component: Dashboard,
        meta: { requiresAuth: true, hideHeader: false }
    },
    {
        path: '/login',
        component: Login,
        meta: { requiresAuth: false, hideHeader: true }
    },
    {
        path: '/tests',
        component: ListTest,
        meta: { requiresAuth: true , hideHeader: false , permission:'tests'}
    },
    {
        path: '/tests/create/:id?',
        component: AddTest,
        meta: { requiresAuth: true , hideHeader: false, permission:'tests' }
    },
    {
        path: '/attempts',
        component: TestAttempt,
        meta: { requiresAuth: true , hideHeader: false , permission:'test-attempts'}
    },
    {
        path: '/interviews',
        component: InterviewList,
        meta: { requiresAuth: true , hideHeader: false, permission:'interviews' }
    },
    {
        path: '/interviews/create/:id?',
        component: AddInterview,
        meta: { requiresAuth: true , hideHeader: false , permission:'interviews'}
    },

    {
        path: '/packages/',
        component: PackageList,
        meta: { requiresAuth: true , hideHeader: false, permission:'packages' }
    },
    {
        path: '/packages/create/:id?',
        component: AddPackage,
        meta: { requiresAuth: true , hideHeader: false, permission:'packages' }
    },
    {
        path: '/categories/',
        component: CategoryList,
        meta: { requiresAuth: true , hideHeader: false, permission:'categories' }
    },
    {
        path: '/categories/create/:id?',
        component: AddCategory,
        meta: { requiresAuth: true , hideHeader: false, permission:'categories' }
    },

    {
        path: '/users/',
        component: UserList,
        meta: { requiresAuth: true , hideHeader: false, permission:'users' }
    },
    {
        path: '/users/create/:id?',
        component: AddUser,
        meta: { requiresAuth: true , hideHeader: false, permission:'users' }
    },
    {
        path: '/payments/',
        component: PaymentList,
        meta: { requiresAuth: true , hideHeader: false, permission:'payments' }
    },
    {
        path: '/system-users/',
        component: SystemUserList,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/system-users/create/:id?',
        component: AddSystemUser,
        meta: { requiresAuth: true , hideHeader: false , permission:'access-control'}
    },
    {
        path: '/roles/',
        component: RoleList,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/roles/create/:id?',
        component: AddRole,
        meta: { requiresAuth: true , hideHeader: false, permission:'access-control' }
    },
    {
        path: '/account/',
        component: Account,
        meta: { requiresAuth: true , hideHeader: false }
    },

    {
        path: '*',
        component: NotFound,
        meta: { requiresAuth: true , hideHeader: false }
    },
];

export default routes;
